<template>
  <div
    class="ticket"
    >
    <template>
        <div class="content">
        <router-link
          class="content__logo"
          tag="figure"
          to="/game"
        >
          <img
            src="@/assets/logo.png"
            alt="logo"
          />
        </router-link>

        <transition name="fade" appear mode="out-in">
          <h2 class="content__title">
            TICKET
          </h2>
        </transition>
      </div>
      <div class="ticket-visual"></div>
      <ticket-input ref="ticketNumber" v-model="ticketNumber" :maxChars="ticketLength"></ticket-input>
    </template>
  </div>
</template>
<script>
import TicketInput from '../ui/TicketInput'
import Products from '@/components/mixins/Products'
import settings from '@/libs/settings'

export default {
  components: { TicketInput },
  name: 'ticket',
  mixins: [Products],
  data () {
    return {
      ticketNumber: '',
      eanUpc: '',
      timeout: null,
      ticketLength: settings.vouchers.numbers
    }
  },
  methods: {
    back () {
      // go back to products with ean
    },
    wrongTicket () {
      if (this.$refs.ticketNumber) {
        this.$refs.ticketNumber.wrongNumber()
      }
    },
    isTicketValid (ticketNumber) {
      return ticketNumber.length === this.ticketLength
    }
  },
  watch: {
    ticketNumber (n) {
      if (n.length === this.ticketLength) {
        this.$api.voucher(n).then(response => {
          this.$router.push({ path: `voucher/${response.data.result.eanupc}/${n}` })
        }).catch(err => {
          this.wrongTicket()
          console.log(err)
        })
      }
    }
  },
  async mounted () {
    await this.$nextTick(() => {
      this.initProducts()
    })
  },
  async beforeCreated () {
    // check Modiface
    this.checkStatus()
    await this.$nextTick(() => {
      console.log(`PRODUCTS PAGE: UPDATE DB`)
      this.updateProducts()
    })
  }
}
</script>
<style lang="scss" scoped>
@import '@/style/css/screens.scss';

.content {
  grid-area: content;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 5%;
  margin-top: 2%;

  &__logo {
    max-width: 350px;
    margin-bottom: 20px;

      @media screen and (max-width: $handheld) {
        max-width: 220px;
      }
      @media screen and (orientation: landscape) and (max-height: $handheld) {
        margin-bottom: 0;
        width: 65%;
      }

    & > img {
      object-fit: contain;
      max-width: inherit;
    }
  }

  &__title {
    font-size: 2rem;
    text-transform: uppercase;
    text-align: center;

    @media screen and (max-width: $handheld) {
      font-size: 1.2rem;
    }

    @media screen and (orientation: landscape) and (max-height: $handheld) {
      font-size: 1.2rem;
    }
  }
}

.ticket {
  .message {
    font-weight: 300;
    font-size: 49px;
    text-align: center;
    text-transform: uppercase;
    line-height: 135%;
    margin-bottom: 0;
    margin-top: 5%;
  }
  .ticket-visual {
    margin-top: 0;
    margin-bottom: 0;
    height: 22%;
    background: url('../../assets/armani-ticket.png') center center no-repeat;
    background-size: contain;
  }
  .submit {
    text-align: center;
    margin-top: 8%;

    button {
      font-size: 28px;
      text-transform: uppercase;
      padding-top: 12px;
      padding-bottom: 12px;
      font-weight: 300;
      letter-spacing: 2px;
      margin-bottom: 0;
      transition: transform 0.15s linear;
    }

    .active > button {
      transform: scale(1.2, 1.2);
    }
  }
  .ticket-input {
    margin: auto;
    text-align: center;
  }
}
.ticket1024x768 {
  .message {
    margin-top: 50px;
    font-size: 22px;
    text-align: center;
    text-transform: uppercase;
  }
  .ticket-visual {
    margin-top: 5%;
    margin-bottom: 0;
    height: 200px;
  }
  .submit {
    button {
    }
  }
}
</style>
